import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { TerminalSignUpComponent } from '../terminal-sign-up/terminal-sign-up.component';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { PermissionEnum } from '../../services/guards/permissions';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalService } from '../../services/terminal.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataTablesResponseViewModel } from '../../models/data-tables-response-view-model';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { DeliveryNoteComponent } from '../delivery-note/delivery-note.component';

@Component({
  selector: 'app-archived-terminals-card',
  templateUrl: './archived-terminals-card.component.html',
  styleUrls: ['./archived-terminals-card.component.scss']
})
export class ArchivedTerminalsCardComponent implements OnInit {
  public dtTrigger: Subject<boolean> = new Subject();
  // public terminals: TerminalViewModel[] = [];
  public terminals: TerminalSignUpComponent[] = [];
  public searchDebounce = new Subject<string>();


  public MerchantName = '';
  public MerchantNumber = '';
  public TerminalId = '';
  public SerialNumber = '';
  public SimNumber = '';

  private searchEndpoint = `${environment.apiUrl}/api/terminal/SearchArchivedTerminals`;
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public terminalIdSearch = '';
  public canView: boolean;
  constructor(private _httpClient: HttpClient,
    private _router: Router,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _toastService: ToastrService,
    private _ngxUiLoaderService: NgxUiLoaderService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ArchiveTerminalTicket], []);
    
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }

    /*
    this.searchDebounce.pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(async value => {
        await this.refreshTable();
      });
      */
  }

  ngOnInit() {
    }

  public async ngAfterViewInit(): Promise<void> {
    this.dtTrigger.next();
    // await this.init();
  }

  public async viewDeliveryNote(terminal: TerminalSignUpViewModel): Promise<void> {
    
    const modalRef = this._modalService.open(DeliveryNoteComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    modalRef.componentInstance.merchantNumberId = terminal.merchantNumber;
    modalRef.componentInstance.terminalId = terminal.terminalId;
    modalRef.componentInstance.data = "Archived";
    if (terminal.bulkOrder) {
      modalRef.componentInstance.type = 'bulk';
    }
    else {
      modalRef.componentInstance.type = 'sigle';
    }//await modalRef.result;

    // Close modal event listener
   

  }


  private async refreshTable(): Promise<void> {
    await this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      this.setupFilters();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  public setupFilters(): void {
    const searchColumns = this.columns.map((col) => {
      if (!!(col).search) {
        return { search: (col).search.value, regex: (col).search.regex };
      } else {
        return null;
      }
    });
    //this.dtOptions.searchCols = searchColumns;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      let i = 0;
      for (const item of searchColumns) {
        if (item) {
          dtInstance.column(i).search(item.search, item.regex);
        }
        i++;
      }
    })
  }

  public columns: any[] = [
    { data: 'merchantName', title: 'Merchant name', visible: true, searchable: true, search: { value: this.MerchantName, regex: true } },
    { data: 'merchantNumber', title: 'Merchant number', visible: true, searchable: true, search: { value: this.MerchantNumber, regex: true } },
    { data: 'terminalId', title: 'Terminal id', visible: true, searchable: true, search: { value: this.TerminalId, regex: true } },
    { data: 'serialNumber', title: 'Serial number', visible: true, searchable: true, search: { value: this.SerialNumber, regex: true } },
    { data: 'simNumber', title: 'Sim number', visible: true, searchable: true, search: { value: this.SimNumber, regex: true } },
  ];

  private searchColumns = this.columns.map((col) => {
    if (!!col.search) {
      return { search: col.search.value, regex: col.search.regex };
    } else {
      return null;
    }
  });

  public dtOptions: DataTables.Settings = {
    pageLength: 10,
    serverSide: true,
    processing: true,
    ajax: (dataTablesParameters: any, callback) => {
      this._httpClient
        .post<DataTablesResponseViewModel>(
          this.searchEndpoint,
          dataTablesParameters, {}
      ).subscribe(resp => {
        
          this.terminals = resp.data;
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });
        });
    },
    columns: this.columns,
    searchCols: this.searchColumns
  };

  public get displayColumns() {
    return this.dtOptions.columns.filter(x => x.visible != false);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}
